/**
 * Format currency based on country
 */
export function formatCurrency(country, value) {
  country = (country || 'au').toLowerCase();
  let locale = country === 'au' ? 'en-AU' : (country === 'uk' ? 'en-GB' : '');
  let currency = country === 'au' ? 'AUD' : (country === 'uk' ? 'GBP' : '');

  const fmt = new Intl.NumberFormat(locale, { maximumSignificantDigits: 10, style: 'currency', currency: currency });

  if (typeof value === 'string' && value.includes('-')) {
    const parts = value.split('-').map(part => parseFloat(part.trim()));
    if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
      return `${fmt.format(parts[0].toFixed())} - ${fmt.format(parts[1].toFixed())}`;
    }
  }

  // Ensure value is treated as a number for formatting
  const numValue = parseFloat(value);
  if (isNaN(numValue)) return value; // Return original if not a number

  return fmt.format(numValue.toFixed());
}
